import Component from "../component.abstract"
import {ALERT, getIcon, getLevel} from "./alert-level";
import { initialiseComponents } from "../../core";
import { NotificationData } from "@utils/notification";
import { getItemFromLocalStorage, removeItemFromLocalStorage, setItemInLocalStorage } from "@utils/local_storage/local_storage.utils";
import {createElementFromHTML} from "@utils/html/html.utils";

export interface NotificationItem {
    AnalyticsTrackings?: string,
    Title?: string
    Message:string,
    Icon:ALERT,
    sticky: boolean,
    vanish?: boolean
}

/**
 * Notification Component
 */
export default class Notification extends Component {
    private notifs: HTMLElement;
    private content: HTMLElement;
    private submitCallback: Function;
    private cancelCallback: Function;
    private notificationActions: Element;
    private submit: HTMLElement;
    private cancel: HTMLElement;

    constructor(
        private props: Object,
        element:HTMLElement
    ) {
        super(props, element)
    }

    mounted():void {
        PubSub.subscribe('notify', (_topic: string, notification: NotificationData) => this.notify(notification));
        PubSub.subscribe("service.error", this.handleServiceError.bind(this));
        PubSub.publish('connected.notifications');

        this.notifs = this.nextSibling() as HTMLElement
        this.closeAlert();
        this.content = this.notifs.querySelector(".notification-content-text");
        this.notificationActions = this.notifs.querySelectorAll('[data-notification-actions]')[0];

        if (this.notificationActions) {
            this.submit = this.notificationActions.querySelector('.submit-button');
            this.cancel = this.notificationActions.querySelector('.cancel-button');

            if (this.submit) {
                this.submit.addEventListener("click", () => this.onClick(this.submitCallback))
            }
            if (this.cancel) {
                this.cancel.addEventListener("click", () => this.onClick(this.cancelCallback));
            }
        }

        if (getItemFromLocalStorage('passwaymessage') !== null) {
            this.notifyFromCookie();
        }
    }

    onClick (callback:Function) {
        this.closeAlert();
        if (callback) {
            setTimeout(callback, 300);
        }
    }

    notify (notification: any) {
        // Clear previous notification
        this.clear();

        // Update icon
        const icon = this.notifs.querySelector('.notification-content > svg');
        const clonedIcon = <Element> icon.cloneNode(true);
        clonedIcon.textContent = "";
        clonedIcon.setAttribute('data-load-url', getIcon(notification.sticky, notification.action));
        icon.replaceWith(clonedIcon);

        // Add close icon
        const cross = createElementFromHTML('<label for="data-notification"></label>');
        this.content.appendChild(cross);

        // Add title
        const title = document.createElement('span');
        title.innerText = notification.title;
        this.content.appendChild(title);

        // Add messages
        if (notification.messages) {
            for (let i = 0; i < notification.messages.length; i++) {
                if (
                    notification.messages[i] &&
                    notification.messages[i].trim().length > 0
                ) {
                    const mess = document.createElement('span');
                    mess.innerText = notification.messages[i];
                    this.content.appendChild(mess);
                }
            }
        }

        if (notification.html) {
            this.content.appendChild(createElementFromHTML(notification.html));
            // playScriptFromHtml(notification.html);
        }

        // Get buttons back
        if (this.notificationActions) {
            this.content.appendChild(this.notificationActions);
        }

        const otherModals = document.querySelectorAll("main [data-modal]");
        for (let i = 0; i < otherModals.length; i++) {
            // @ts-ignore
            otherModals[i].checked = false;
        }
        // @ts-ignore
        this.element.checked = true;
        this.element.classList.remove("pending");
        this.element.classList.remove(
            "ok",
            "confirm",
            "error",
            "Application",
            "sticky"
        );
        if (notification.action) {
            this.element.classList.add(notification.action);
        }
        if (notification.sticky) {
            this.element.classList.add("sticky");
        }

        // Vanish
        const vanish = (notification.vanish !== undefined) ? notification.vanish : false;
        if (vanish) {
            const timer = (vanish === true) ? 5000 : parseInt(vanish);

            setTimeout(() => {this.closeAlert()}, timer);
        }

        // Update buttons
        if (this.notificationActions) {
            // @ts-ignore
            this.submit.value = "Ok";
            // @ts-ignore
            this.cancel.value = "Annuler";
            this.element.classList.remove("hasOk");
            this.element.classList.remove("hasCancel");
            if (notification.okButton) {
                // @ts-ignore
                this.submit.value = notification.okButton;
            }
            if (notification.cancelButton) {
                // @ts-ignore
                this.cancel.value = notification.cancelButton;
            }
            this.submitCallback = undefined;
            if (notification.okCallback) {
                this.element.classList.add("hasOk");
                this.submitCallback = notification.okCallback;
            }
            this.cancelCallback = undefined;
            if (notification.cancelCallback) {
                this.element.classList.add("hasCancel");
                this.cancelCallback = notification.cancelCallback;
            } else {
                if (notification.cancelButton) {
                    this.element.classList.add("hasCancel");
                    this.cancelCallback = () => {
                        this.closeAlert();
                    };
                }
            }
        }

        initialiseComponents();
    }

    closeAlert () {
        // @ts-ignore
        this.element.checked = false;
        this.element.classList.add('pending');
    }

    notifyFromAlert ({ Title, Message, Icon, sticky, vanish }: NotificationItem) {
        this.clear()
          let title = Title && Title !== "" ? Title : "";
        const messages:string[] = [];

        if(Message && Message !== "") {
            if(title ==="") {
                title = Message
                messages.push("");
            } else {
                 messages.push(Message);
            }
        } else {
             messages.push("");
        }

        if (title.length !== 0) {
            this.notify({
                action: getLevel(Icon),
                messages: messages,
                sticky,
                title,
                vanish
            });
        }
        
    }

    notifyFromCookie () {
        const data = JSON.parse(getItemFromLocalStorage('passwaymessage'));

        if (data != null) {
            this.notify({
                action: 'ok',
                title: data.title,
                messages: [data.message]
            })
            removeItemFromLocalStorage('passwaymessage');
        }
    }

    clear () {
        if (this.content) {
            this.content.innerHTML = '';
        }
    }

    notifyOnNextPage (notif: any) {
        if (notif) {
            notif.action = notif.action || 'ok';
            if (!notif.title || !notif.title.trim().length) {
                notif.title = false;
                if (Array.isArray(notif.message)) {
                    while (!notif.title && notif.message.length) {
                        const sh = notif.message.shift();
                        if (sh.trim().length) {
                            notif.title = sh.trim();
                        }
                    }
                } else {
                    notif.title = notif.message.trim();
                    delete notif.message;
                }
            }
            if (notif.message && !Array.isArray(notif.message)) {
                notif.message = [notif.message];
            }
            if (notif.title && notif.title.trim().length) {
                setItemInLocalStorage('passwaymessage', JSON.stringify(notif));
            }
        }
    }

    handleServiceError(topic: string, notification: any) {
        this.notify(notification);
    }
}